import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { notification } from "antd";

// assets
import { LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
//import CustomIcons from 'components/CustomIcons';

function NotificationSimple({
  Loading,
  type,
  Successful,
  // default props
  message,
  messageSuccess,
  description,
  descriptionError,
}) {
  const { t } = useTranslation();

  const defaultMessage = `${t("common.delete")}!`;
  const defaultMessageSuccess = `${t("common.deleted")}!`;
  const defaultDescription = t("notifications.notifSimpleDescription");
  const defaultDescriptionError = t("errors.notifSimpleError");

  // Loading Notifications
  useEffect(() => {
    if (Loading || Successful) {
      simpleNotification(Loading, Successful);
    }
    return () => {
      notification.destroy();
    };
  }, [Loading, Successful]);

  const COLOR = {
    update: "#005D9F",
    delete: "#E02020",
    load: "#BE7700",
    new: "#005D9F",
    success: "#3F7A00",
  };

  const simpleNotification = useCallback(
    (Loading, Successful) => {
      if (!Loading || !Successful) {
        notification.destroy();
      }
      if (!!Loading && !Successful) {
        notification.destroy();
        notification.open({
          duration: null,
          icon: (
            <>
              {Loading && !Successful && (
                <LoadingOutlined style={{ color: COLOR["load"] }} />
              )}
            </>
          ),
          message: Successful ? (
            !!messageSuccess && messageSuccess || defaultMessageSuccess
          ) : (
            !!message && message || defaultMessage
          ),
          description: Successful ? (
            !!description && description || defaultDescription
          ) : (
            !!descriptionError && descriptionError || defaultDescriptionError
          ),
        });
      }
      if (!!Successful) {
        notification.destroy();
        notification.open({
          duration: 2,
          icon: (
            <>
              {Successful && (
                <CheckCircleOutlined style={{ color: COLOR[type] }} />
              )}
            </>
          ),
          message: Successful ? messageSuccess : message,
          description: Successful ? description : descriptionError,
        });
      }
    },
    [
      description,
      descriptionError,
      messageSuccess,
      message,
      Loading,
      Successful,
    ],
  );

  return <></>;
}

NotificationSimple.defaultProps = {
  Loading: false,
  Successful: false,
  type: "success"
};

NotificationSimple.propTypes = {
  type: PropTypes.oneOf(["update", "delete", "load", "new", "success"])
    .isRequired,
};

export default NotificationSimple;
